if (!customElements.get("related-products")) {
  customElements.define(
    "related-products",
    class RelatedProducts extends HTMLElement {
      getBlock() {
        const wrapper = this.closest("[data-related-products-block]");
        if (wrapper) return wrapper;
        if (this.closest("header-element, drawer-element")) return null;
        return this.closest(".shopify-section");
      }

      buildUrl(intent) {
        if (this.dataset.url) {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set("intent", intent);
          return url.toString();
        }

        const base =
          window.routes?.product_recommendations_url ||
          "/recommendations/products";
        const sectionId =
          this.dataset.sectionId || "api--cart-drawer-recommendations";
        const productId = this.dataset.productId;
        const limit = this.dataset.limit || 8;

        if (!productId) return null;

        const url = new URL(base, window.location.origin);
        url.searchParams.set("section_id", sectionId);
        url.searchParams.set("product_id", productId);
        url.searchParams.set("limit", limit);
        url.searchParams.set("intent", intent);
        return url.toString();
      }

      extractContent(htmlText) {
        const html = document.createElement("div");
        html.innerHTML = htmlText;

        const nested = html.querySelector("related-products");
        if (nested?.innerHTML.trim().length) {
          return nested.innerHTML;
        }

        const slider = html.querySelector("slider-component");
        if (slider) {
          return slider.outerHTML;
        }

        const section = html.querySelector(".shopify-section");
        if (section?.innerHTML.trim().length) {
          return section.innerHTML;
        }

        return null;
      }

      async fetchIntent(intent) {
        const url = this.buildUrl(intent);
        if (!url) return null;

        const response = await fetch(url);
        if (!response.ok) return null;

        const text = await response.text();
        return this.extractContent(text);
      }

      connectedCallback() {
        const block = this.getBlock();

        const hideBlock = () => {
          block?.classList.add("hidden");
          this.innerHTML = "";
        };

        const showBlock = () => {
          block?.classList.remove("hidden");
        };

        this.loadRecommendations = async () => {
          const intents = (this.dataset.intents || "complementary,related")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);

          try {
            for (const intent of intents) {
              const content = await this.fetchIntent(intent);
              if (content) {
                this.innerHTML = content;
                showBlock();
                return;
              }
            }
            hideBlock();
          } catch {
            hideBlock();
          }
        };

        this.onCartUpdate = () => {
          if (!this.isConnected) return;
          this.loadRecommendations();
        };

        this.onDrawerOpen = (event) => {
          if (event.detail?.drawerId !== "cart-drawer") return;
          if (!this.closest("#cart-drawer")) return;
          this.loadRecommendations();
        };

        document.addEventListener("cart:update", this.onCartUpdate);
        document.addEventListener("drawer:opened", this.onDrawerOpen);

        this.loadRecommendations();
      }

      disconnectedCallback() {
        if (this.onCartUpdate) {
          document.removeEventListener("cart:update", this.onCartUpdate);
        }
        if (this.onDrawerOpen) {
          document.removeEventListener("drawer:opened", this.onDrawerOpen);
        }
      }
    }
  );
}
